module.exports = {"410783001":"蒲西街道","410783002":"蒲东街道","410783003":"南蒲街道","410783004":"蒲北街道","410783005":"魏庄街道","410783100":"丁栾镇","410783101":"樊相镇","410783102":"恼里镇","410783103":"常村镇","410783104":"赵堤镇","410783105":"孟岗镇","410783106":"满村镇","410783107":"苗寨镇","410783108":"张三寨镇","410783109":"方里镇","410783110":"佘家镇","410783201":"芦岗乡","410783202":"武邱乡","410783460":"河南长垣起重工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410783.json
// module id = 1718
// module chunks = 0